(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["fui"] = factory(require("react"));
	else
		root["fui"] = factory(root["react"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__39155__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 11700:
/***/ ((module) => {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 13394:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f=__webpack_require__(39155),k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}exports.Fragment=l;exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 39155:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__39155__;

/***/ }),

/***/ 64922:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


if (true) {
  module.exports = __webpack_require__(13394);
} else {}


/***/ }),

/***/ 69122:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 73102:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64922);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69122);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _form_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98332);



const FormError = ({ touched = false, error = '', warning = '', submitError, modifiedSinceLastSubmit, className, dataTest = 'formError', }) => {
    if (touched && (error || (!modifiedSinceLastSubmit && submitError))) {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_form_scss__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.formError, className), "data-test": dataTest, children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: error || submitError }) }));
    }
    if (touched && warning) {
        return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", { className: _form_scss__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.formWarning, "data-test": dataTest, children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", { children: warning }) }));
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FormError);


/***/ }),

/***/ 79878:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FormError: () => (/* reexport safe */ _FormError__WEBPACK_IMPORTED_MODULE_0__.A)
/* harmony export */ });
/* harmony import */ var _FormError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73102);


/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (FormError)));


/***/ }),

/***/ 84168:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ isDefined)
/* harmony export */ });
/**
 * Check if a value is defined
 * @param {*} value
 * @return {Boolean}
 */
function isDefined(value) {
    return value !== undefined && value !== null;
}


/***/ }),

/***/ 98332:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
// extracted by mini-css-extract-plugin
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","screenXXs":"320px","screenXs":"480px","screen568":"568px","screen640":"640px","screenS":"768px","screenM":"1024px","screen1126":"1126px","screenL":"1440px","formWrp":"src-components-Form-form_formWrp","panelGroupWithTable":"src-components-Form-form_panelGroupWithTable","formLabel":"src-components-Form-form_formLabel","formLabel2":"src-components-Form-form_formLabel2","formLabelIcon":"src-components-Form-form_formLabelIcon","formError":"src-components-Form-form_formError","formWarning":"src-components-Form-form_formWarning","formCheckbox":"src-components-Form-form_formCheckbox","formInnerSection":"src-components-Form-form_formInnerSection","borderedSection":"src-components-Form-form_borderedSection","formInput":"src-components-Form-form_formInput"});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Checkbox: () => (/* reexport */ Checkbox_Checkbox_Checkbox),
  CheckboxInput: () => (/* reexport */ Checkbox_Checkbox_CheckboxInput),
  checkboxStyles: () => (/* reexport */ Checkbox_Checkbox_checkbox),
  "default": () => (/* binding */ Checkbox_components_Checkbox)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var Checkbox_jsx_runtime = __webpack_require__(64922);
// EXTERNAL MODULE: external "react"
var Checkbox_external_react_ = __webpack_require__(39155);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var Checkbox_classnames = __webpack_require__(69122);
var Checkbox_classnames_default = /*#__PURE__*/__webpack_require__.n(Checkbox_classnames);
// EXTERNAL MODULE: ./node_modules/lodash/noop.js
var Checkbox_noop = __webpack_require__(11700);
var Checkbox_noop_default = /*#__PURE__*/__webpack_require__.n(Checkbox_noop);
;// ./src/components/Checkbox/checkbox.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ const Checkbox_Checkbox_checkbox = ({"firmColor":"#5d3b84","secondaryColor":"silver","successColor":"#4ab675","checkbox":"src-components-Checkbox-checkbox_checkbox","isNoLabel":"src-components-Checkbox-checkbox_isNoLabel","input":"src-components-Checkbox-checkbox_input","control":"src-components-Checkbox-checkbox_control","formCheckboxInput":"src-components-Checkbox-checkbox_formCheckboxInput","formCheckboxControl":"src-components-Checkbox-checkbox_formCheckboxControl","label":"src-components-Checkbox-checkbox_label","isError":"src-components-Checkbox-checkbox_isError"});
;// ./src/components/Checkbox/Checkbox.tsx





const components_Checkbox_Checkbox = (props) => {
    var _a, _b, _c;
    const { label, className = '', controlClassName = '', supportIndeterminate = false, indeterminate = false, labelClassName = '', name, id, type = 'checkbox', disabled = false, readOnly, tabIndex = 0, onClick = (Checkbox_noop_default()), onFocus = (Checkbox_noop_default()), onChange = (Checkbox_noop_default()), onBlur = (Checkbox_noop_default()), dataTest, value, defaultChecked, } = props;
    const [checked, setChecked] = (0,Checkbox_external_react_.useState)(!!((_a = props.checked) !== null && _a !== void 0 ? _a : (_b = props.input) === null || _b === void 0 ? void 0 : _b.checked));
    const checkboxRef = (0,Checkbox_external_react_.useRef)(null);
    if (checkboxRef.current) {
        checkboxRef.current.indeterminate = supportIndeterminate && indeterminate;
    }
    (0,Checkbox_external_react_.useEffect)(() => {
        var _a, _b;
        setChecked(!!((_a = props === null || props === void 0 ? void 0 : props.checked) !== null && _a !== void 0 ? _a : (_b = props.input) === null || _b === void 0 ? void 0 : _b.checked));
    }, [props.checked, (_c = props.input) === null || _c === void 0 ? void 0 : _c.checked]);
    const nextValue = (oldValue) => !!oldValue === !!indeterminate
        || (!oldValue && !!indeterminate);
    const handleChange = (event) => {
        var _a;
        event.persist();
        if (disabled) {
            return;
        }
        let value = event.target.checked;
        if (supportIndeterminate) {
            if (typeof props.nextValue === 'function') {
                value = props.nextValue(!!checked, props);
            }
            else {
                value = nextValue(checked);
            }
        }
        setChecked(value);
        const newEvent = {
            target: Object.assign(Object.assign({}, props), { checked: value }),
            stopPropagation() {
                event.stopPropagation();
            },
            preventDefault() {
                event.preventDefault();
            },
        };
        onChange(newEvent);
        // Final-Form's onChange
        (_a = props.input) === null || _a === void 0 ? void 0 : _a.onChange(newEvent);
    };
    const containerCls = Checkbox_classnames_default()(Checkbox_Checkbox_checkbox.checkbox, {
        [Checkbox_Checkbox_checkbox.isNoLabel]: !label,
    }, className);
    const controlCls = Checkbox_classnames_default()(Checkbox_Checkbox_checkbox.control, controlClassName);
    const labelCls = Checkbox_classnames_default()(Checkbox_Checkbox_checkbox.label, labelClassName);
    return ((0,Checkbox_jsx_runtime.jsxs)("label", { htmlFor: id, className: containerCls, "data-test": dataTest || name, children: [(0,Checkbox_jsx_runtime.jsx)("input", { className: Checkbox_Checkbox_checkbox.input, type: type, id: id, name: name, readOnly: readOnly, disabled: disabled, 
                // @ts-ignore
                tabIndex: tabIndex, checked: !!checked, defaultChecked: !!defaultChecked, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onChange: handleChange, ref: checkboxRef, value: value }), (0,Checkbox_jsx_runtime.jsx)("div", { className: controlCls }), label && ((0,Checkbox_jsx_runtime.jsx)("div", { className: labelCls, children: label }))] }));
};
/* harmony default export */ const Checkbox_Checkbox_Checkbox = ((0,Checkbox_external_react_.memo)(components_Checkbox_Checkbox));

// EXTERNAL MODULE: ./src/components/Form/FormError/index.ts
var Checkbox_FormError = __webpack_require__(79878);
// EXTERNAL MODULE: ./src/utils/dataHelpers/isDefined.ts
var Checkbox_isDefined = __webpack_require__(84168);
;// ./src/components/Checkbox/CheckboxInput.tsx






const components_Checkbox_CheckboxInput = (props) => {
    const { className, input, meta, isErrorMessage = true, disabled, } = props;
    const isError = !!(meta && meta.touched && meta.error);
    return ((0,Checkbox_jsx_runtime.jsxs)(Checkbox_jsx_runtime.Fragment, { children: [(0,Checkbox_jsx_runtime.jsx)(Checkbox_Checkbox_Checkbox, Object.assign({}, props, input, { className: Checkbox_classnames_default()([{ [Checkbox_Checkbox_checkbox.isError]: isErrorMessage && isError }, className]), id: props.id || input.name, checked: (0,Checkbox_isDefined/* default */.A)(input.checked) ? !!input.checked : !!input.value, disabled: disabled })), isErrorMessage && !input['aria-expanded'] && (0,Checkbox_jsx_runtime.jsx)(Checkbox_FormError.FormError, Object.assign({}, props.meta))] }));
};
/* harmony default export */ const Checkbox_Checkbox_CheckboxInput = (components_Checkbox_CheckboxInput);

;// ./src/components/Checkbox/index.ts




/* harmony default export */ const Checkbox_components_Checkbox = (Checkbox_Checkbox_Checkbox);

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map